<div class="lang" [class.lang--open]="open()">
  <button
    type="button"
    class="lang__trigger"
    [attr.aria-expanded]="open()"
    aria-haspopup="listbox"
    [attr.aria-label]="'language.choose' | t"
    [title]="'language.choose' | t"
    (click)="toggle()">
    <img class="lang__flag" [src]="current().flag" [alt]="current().labelKey | t" width="22" height="16" />
    <span class="lang__chevron" aria-hidden="true"></span>
  </button>

  @if (open()) {
    <div class="lang__menu" role="listbox" [attr.aria-label]="'language.choose' | t">
      <div class="lang__menu-head">
        <span class="lang__menu-title">{{ 'language.choose' | t }}</span>
        <span class="lang__menu-caption">{{ 'language.caption' | t }}</span>
      </div>
      <ul class="lang__list">
        @for (language of languages; track language.code) {
          <li>
            <button
              type="button"
              class="lang__option"
              role="option"
              [attr.aria-selected]="language.code === currentCode()"
              [class.lang__option--active]="language.code === currentCode()"
              [title]="language.labelKey | t"
              (click)="select(language)">
              <img class="lang__flag" [src]="language.flag" [alt]="language.labelKey | t" width="22" height="16" />
              <span class="lang__option-label">{{ language.labelKey | t }}</span>
              @if (language.code === currentCode()) {
                <span class="lang__check" aria-hidden="true"></span>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  }
</div>
